/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 删除锁定座位
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  uuid: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "delete",
    url: `/order/lock-seat/${uuid}`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
